import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { UpdateAccountModalAccountFragmentDoc } from './UpdateAccountModalAccount.generated'
import * as Types from './purchasePlus_graphql'

export const AccountMoreOptionsMenuAccountFragmentDoc = gql`
  fragment AccountMoreOptionsMenuAccount on Account {
    id
    children {
      totalCount
    }
    ...UpdateAccountModalAccount
  }
  ${UpdateAccountModalAccountFragmentDoc}
` as unknown as DocumentNode<Types.AccountMoreOptionsMenuAccountFragment, unknown>
